var _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "43.3 26.7 10 26.7 10 33.3 23.3 33.3 23.3 73.3 30 73.3 30 33.3 43.3 33.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 23.3v-6.7c-4 0-7.6 1.8-10 4.6 -2.4-2.8-6-4.6-10-4.6v6.7c3.7 0 6.7 3 6.7 6.7v40c0 3.7-3 6.7-6.7 6.7v6.7c4 0 7.6-1.8 10-4.6 2.4 2.8 6 4.6 10 4.6v-6.7c-3.7 0-6.7-3-6.7-6.7V30C83.3 26.3 86.3 23.3 90 23.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 65.7c-0.6 0.6-1.4 1-2.4 1 -1.8 0-3.3-1.5-3.3-3.3V50h6.7v-6.7h-6.7v-10H50v10h-6.7V50H50v13.3c0 5.5 4.5 10 10 10 2.8 0 5.3-1.1 7.1-2.9L62.4 65.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringIcon);
export default __webpack_public_path__ + "static/media/stringIcon.c5653b9fba9712de62d065c157811a5a.svg";
export { ForwardRef as ReactComponent };